import React from 'react';
import { RouterSwitch } from '../components/router/switch/RouterSwitch';
import { RootIdPage } from './id/RootIdPage';
import { OrderIdPage } from './order/id/OrderIdPage';
import { DevPage } from './dev/DevPage';
import { PaymentReturnPage } from './payment/return/PaymentReturnPage';
import { LayoutBottomNavigation } from '../components/layout/bottom-navigation/LayoutBottomNavigation';
import { OrderHistoryPage } from './order/history/OrderHistoryPage';
import { BrowsePage } from './browse/BrowsePage';
import { AccountPage } from './account/AccountPage';
import { LocationPage } from './location/LocationPage';
import { ScanPage } from './scan/ScanPage';
import { PaymentIdPage } from './payment/id/PaymentIdPage';

export function RootPage() {
    const rootRoute = {
        component: Index,
        exact: true,
    };

    return (
        <>
            <RouterSwitch
                routes={[
                    rootRoute,
                    {
                        component: RootIdPage,
                        path: '/tag/:id',
                    },
                    ScanPage,
                    BrowsePage,
                    OrderHistoryPage,
                    DevPage,
                    OrderIdPage,
                    PaymentReturnPage,
                    PaymentIdPage,
                    AccountPage,
                    LocationPage,
                    RootIdPage,
                ]}
            />

            <LayoutBottomNavigation />
        </>
    );
}

function Index() {
    return <RootIdPage />;
}

RootPage.route = '/';
Index.route = RootPage.route;
